import useFetchAvisos from 'features/avisos/hooks/useFetchAvisos'
import { createContext, useState } from 'react'

let AvisosContext

const { Provider } = (AvisosContext = createContext())

const AvisosProvider = ({ children }) => {
  const [iteration, setIteration] = useState(0)
  const { response, loading, error } = useFetchAvisos({ iteration })

  function forceRefresh() {
    setIteration(iteration + 1)
  }

  const avisos = response?.avisos || []

  return (
    <Provider
      value={{ forceRefresh, count: response?.avisos?.length ?? 0, avisos, loading, error }}
    >
      {children}
    </Provider>
  )
}

export { AvisosContext, AvisosProvider }
